import { render, staticRenderFns } from "./HospB.vue?vue&type=template&id=2f870340&scoped=true"
import script from "./HospB.vue?vue&type=script&lang=js"
export * from "./HospB.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f870340",
  null
  
)

export default component.exports